export const toConnectArticleId = (source: {
  id?: string | number;
  articleId?: number | string | null;
}): number | undefined => {
  const rawId = source.articleId ?? source.id;

  if (rawId == null) {
    return undefined;
  }

  if (typeof rawId === 'number') {
    return Number.isFinite(rawId) ? rawId : undefined;
  }

  const trimmedId = String(rawId).trim();

  if (trimmedId === '') {
    return undefined;
  }

  const numericId = Number(trimmedId);

  return Number.isFinite(numericId) ? numericId : undefined;
};
